<template>
  <div>
    <div class="el-card__header card-header__wrap">
      <span class="card-header--title"></span>
      <div class="card-header--form">
        <assign-ent-select v-model="config.refVendorId"
          immediate
          style="margin-right: 10px"
          :option="{tagType: null, tagModel: 1}"
          :callback="() => {handleCurrentChange(1)}" />
        <el-input placeholder="请输入序号"
          v-model="config.setNo"
          style="width:200px"
          clearable>
          <el-button slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </div>
    </div>
    <el-table border
      v-loading="loading"
      :data="list">
      <el-table-column label="购买企业"
        prop="refVendorName">
      </el-table-column>
      <el-table-column label="套码序号"
        width="200">
        <template slot-scope="{row}">
          {{row.beginSetNo | tagCount() }} - {{row.endSetNo | tagCount() }}
          <el-tag v-if="row.isPreassign === 1"
            size="mini">企业专属</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="标签类型">
        <template slot-scope="{row}">
          {{row.tagType | tagType()}}
        </template>
      </el-table-column>
      <el-table-column label="包装规格">
        <template slot-scope="{row}">
          {{row.corratio}}个/套
        </template>
      </el-table-column>
      <el-table-column label="套码数量"
        prop="setCount">
      </el-table-column>
      <el-table-column label="标签数量"
        prop="tagCount">
      </el-table-column>
      <el-table-column label="购买时间">
        <template slot-scope="{row}">
          {{row.createdTime | dateformat('YYYY-MM-DD') }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background
      @current-change="handleCurrentChange"
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import AssignEntSelect from '@/components/business/assign-ent-select.vue'
export default {
  name: 'distribute-table',
  components: { AssignEntSelect },
  data () {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        refVendorId: null,
        setNo: ''
      },
      list: [],
      total: 0
    }
  },
  methods: {
    getsetassigns () {
      this.loading = true
      this.$store.dispatch('label/getsetassigns', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.list = res.data.records
          this.total = res.data.total
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.getsetassigns()
    }
  },
  mounted () {
    this.getsetassigns()
  }
}
</script>
